import { watchers as contactsWatchers } from '../contacts';

import { watchers as commonWatchers } from './commonSagas';
import { watchers as tasksWatchers } from '../tasks';
import { watchers as contactWatchers } from '../users';
import { watchers as analyticsWatchers } from '../analytics';
import { watchers as financesWatchers } from '../finances';
import { watchers as linkDistributionWatchers } from '../link_distribution/_redux/index';

export default [
  ...commonWatchers,
  ...contactWatchers,
  ...tasksWatchers,
  ...contactsWatchers,
  ...analyticsWatchers,
  ...financesWatchers,
  ...linkDistributionWatchers,
];
